import {createStore} from 'vuex'
import createPersistedstate from 'vuex-persistedstate';

export default createStore({
    state: {
        saToken: '',
    },
    getters: {},
    mutations: {
        /**
         * @author: kxf
         * @createDate: 2025/11/19
         * @description: 控制首次登录表填
         * 入参解释:
         * 返回值解释:
         * @steps：
         */
        setSaToken(state, value) {
            state.saToken = value;
        },
    },
    actions: {},
    modules: {},
    plugins: [
        createPersistedstate({
            key: 'state',
        }),
    ],
})
